var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 606,
    viewBox: "0 0 584 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5131_565702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584 413.467L583.945 441.207C583.945 443.456 582.446 445.698 579.503 447.465L311.354 603.317C305.366 606.798 295.527 606.798 289.428 603.317L4.59985 438.729C1.55432 437.016 0 434.665 0 432.368L0.0552298 404.675C0.0552298 407.027 1.60166 409.276 4.65508 411.091L584.008 413.467H584Z",
    fill: "#117A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.199 604.864V577.155C291.898 576.753 290.643 576.271 289.546 575.632L4.64728 411.099C1.59386 409.3 0.063209 407.011 0.063209 404.675L0.0158691 432.384C0.0158691 434.672 1.54652 437.008 4.59994 438.76L289.452 603.341C290.58 603.98 291.858 604.461 293.199 604.872",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.486 419.733C360.768 546.921 420.614 512.101 311.409 575.601C305.42 579.136 295.581 579.136 289.522 575.601L18.7302 419.228L4.67027 411.091C3.97595 410.713 3.40787 410.271 2.90291 409.829C-1.38134 406.356 -0.821153 401.503 4.54403 398.409L272.622 242.541C278.673 239.006 288.449 239.006 294.501 242.541L579.423 407.051C585.475 410.586 585.538 416.261 579.486 419.733Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.615 152.027L231.445 24.334L117 90.4091L338.172 218.102L452.615 152.027Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.212 468.229L117.041 340.535V100.155L338.212 227.849V468.229Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.969 138.66L124.666 128.67V116.92L141.969 126.91V138.66Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.162 161.866L176.898 158.828V147.075L182.162 150.115V161.866Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.123 166.464L184.861 163.424V151.673L190.123 154.712V166.464Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.087 171.059L192.823 168.021V156.27L198.087 159.309V171.059Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05 175.657L200.785 172.619V160.867L206.05 163.905V175.657Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.717 143.133L167.019 153.123V141.371L149.717 131.382V143.133Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.019 159.021L124.666 134.568V128.67L167.019 153.124V159.021Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.284 237.57L330.588 247.56V235.808L313.284 225.819V237.57Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.091 214.365L278.354 217.403V205.652L273.091 202.613V214.365Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.129 209.767L270.392 212.805V201.054L265.129 198.016V209.767Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.166 205.171L262.429 208.21V196.458L257.166 193.42V205.171Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.204 200.574L254.467 203.612V191.861L249.204 188.822V200.574Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.537 233.097L288.234 223.107V211.355L305.537 221.345V233.097Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.234 229.005L330.588 253.458V247.56L288.234 223.107V229.005Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7 194.509L216.552 181.721V169.97L238.7 182.757V194.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.969 170.935L124.666 160.945V149.193L141.969 159.182V170.935Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.162 194.14L176.898 191.101V179.351L182.162 182.389V194.14Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.123 198.738L184.861 195.699V183.947L190.123 186.987V198.738Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.087 203.335L192.823 200.295V188.544L198.087 191.582V203.335Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05 207.933L200.785 204.893V193.142L206.05 196.18V207.933Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.717 175.408L167.019 185.398V173.646L149.717 163.656V175.408Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.019 191.296L124.666 166.842V160.945L167.019 185.398V191.296Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.284 269.844L330.588 279.832V268.081L313.284 258.091V269.844Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.091 246.638L278.354 249.677V237.926L273.091 234.887V246.638Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.129 242.041L270.392 245.08V233.328L265.129 230.289V242.041Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.166 237.445L262.429 240.483V228.732L257.166 225.692V237.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.204 232.847L254.467 235.886V224.134L249.204 221.096V232.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.537 265.37L288.234 255.38V243.629L305.537 253.619V265.37Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.234 261.279L330.588 285.731V279.833L288.234 255.381V261.279Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7 226.782L216.552 213.996V202.243L238.7 215.03V226.782Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.969 203.207L124.666 193.217V181.466L141.969 191.456V203.207Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.162 226.413L176.898 223.375V211.623L182.162 214.661V226.413Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.123 231.011L184.861 227.972V216.221L190.123 219.259V231.011Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.087 235.607L192.823 232.569V220.816L198.087 223.856V235.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05 240.204L200.785 237.166V225.414L206.05 228.452V240.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.717 207.68L167.019 217.67V205.919L149.717 195.929V207.68Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.019 223.568L124.666 199.115V193.218L167.019 217.67V223.568Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.284 302.115L330.588 312.105V300.354L313.284 290.363V302.115Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.091 278.911L278.354 281.95V270.197L273.091 267.159V278.911Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.129 274.313L270.392 277.352V265.601L265.129 262.562V274.313Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.166 269.716L262.429 272.756V261.004L257.166 257.966V269.716Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.204 265.12L254.467 268.159V256.406L249.204 253.368V265.12Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.537 297.643L288.234 287.654V275.901L305.537 285.891V297.643Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.234 293.551L330.588 318.003V312.106L288.234 287.654V293.551Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7 259.055L216.552 246.267V234.516L238.7 247.303V259.055Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.969 235.48L124.666 225.49V213.738L141.969 223.728V235.48Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.162 258.686L176.898 255.647V243.896L182.162 246.934V258.686Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.123 263.283L184.861 260.245V248.492L190.123 251.532V263.283Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.087 267.88L192.823 264.842V253.089L198.087 256.128V267.88Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05 272.477L200.785 269.438V257.687L206.05 260.726V272.477Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.717 239.954L167.019 249.943V238.191L149.717 228.201V239.954Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.019 255.84L124.666 231.388V225.49L167.019 249.943V255.84Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.284 334.389L330.588 344.379V332.628L313.284 322.638V334.389Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.091 311.184L278.354 314.223V302.471L273.091 299.432V311.184Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.129 306.587L270.392 309.625V297.873L265.129 294.835V306.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.166 301.99L262.429 305.028V293.277L257.166 290.238V301.99Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.204 297.392L254.467 300.43V288.68L249.204 285.641V297.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.537 329.915L288.234 319.925V308.174L305.537 318.165V329.915Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.234 325.825L330.588 350.277V344.379L288.234 319.926V325.825Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7 291.328L216.552 278.542V266.79L238.7 279.576V291.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.969 267.752L124.666 257.763V246.011L141.969 256.001V267.752Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.162 290.959L176.898 287.92V276.168L182.162 279.206V290.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.123 295.555L184.861 292.517V280.766L190.123 283.804V295.555Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.087 300.152L192.823 297.113V285.362L198.087 288.401V300.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05 304.75L200.785 301.71V289.96L206.05 292.998V304.75Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.717 272.225L167.019 282.216V270.465L149.717 260.475V272.225Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.019 288.113L124.666 263.66V257.764L167.019 282.216V288.113Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.284 366.662L330.588 376.652V364.9L313.284 354.91V366.662Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.091 343.457L278.354 346.495V334.744L273.091 331.704V343.457Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.129 338.859L270.392 341.899V330.146L265.129 327.106V338.859Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.166 334.262L262.429 337.302V325.55L257.166 322.511V334.262Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.204 329.665L254.467 332.704V320.952L249.204 317.913V329.665Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.537 362.189L288.234 352.198V340.447L305.537 350.437V362.189Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.234 358.096L330.588 382.55V376.652L288.234 352.198V358.096Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7 323.6L216.552 310.814V299.062L238.7 311.849V323.6Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.969 300.025L124.666 290.035V278.283L141.969 288.273V300.025Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.162 323.231L176.898 320.193V308.44L182.162 311.48V323.231Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.123 327.828L184.861 324.79V313.038L190.123 316.076V327.828Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.087 332.425L192.823 329.386V317.635L198.087 320.673V332.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05 337.022L200.785 333.984V322.231L206.05 325.271V337.022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.717 304.499L167.019 314.489V302.736L149.717 292.747V304.499Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.019 320.386L124.666 295.933V290.035L167.019 314.489V320.386Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.284 398.934L330.588 408.924V397.172L313.284 387.184V398.934Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.091 375.728L278.354 378.767V367.016L273.091 363.978V375.728Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.129 371.131L270.392 374.17V362.418L265.129 359.38V371.131Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.166 366.535L262.429 369.574V357.821L257.166 354.783V366.535Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.204 361.937L254.467 364.976V353.225L249.204 350.187V361.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.537 394.461L288.234 384.471V372.72L305.537 382.709V394.461Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.234 390.369L330.588 414.821V408.924L288.234 384.472V390.369Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7 355.873L216.552 343.087V331.335L238.7 344.123V355.873Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.969 332.299L124.666 322.309V310.558L141.969 320.547V332.299Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.162 355.505L176.898 352.465V340.714L182.162 343.753V355.505Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.123 360.103L184.861 357.063V345.312L190.123 348.351V360.103Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.087 364.699L192.823 361.66V349.908L198.087 352.947V364.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05 369.296L200.785 366.258V354.505L206.05 357.544V369.296Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.717 336.772L167.019 346.761V335.011L149.717 325.021V336.772Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.019 352.66L124.666 328.206V322.31L167.019 346.761V352.66Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.284 431.208L330.588 441.197V429.445L313.284 419.455V431.208Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.091 408.003L278.354 411.041V399.29L273.091 396.251V408.003Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.129 403.405L270.392 406.443V394.693L265.129 391.653V403.405Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.166 398.809L262.429 401.848V390.096L257.166 387.057V398.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.204 394.212L254.467 397.25V385.498L249.204 382.46V394.212Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.537 426.735L288.234 416.745V404.993L305.537 414.983V426.735Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.234 422.643L330.588 447.095V441.198L288.234 416.745V422.643Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7 388.147L216.552 375.359V363.607L238.7 376.394V388.147Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.212 218.087L117.041 90.3936V100.155L338.212 227.849V218.087Z",
    fill: "#FF0F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.212 513.631L117.041 385.937V340.535L338.212 468.229V513.631Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.823 429.691L176.898 420.497V387.071L192.823 396.266V429.691Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.354 479.072L262.429 469.878V436.453L278.354 445.647V479.072Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.212 468.229L452.66 402.152V161.772L338.212 227.849V468.229Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.212 218.087L452.66 152.011V161.772L338.212 227.849V218.087Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.212 513.631L452.66 447.555V402.152L338.212 468.229V513.631Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.563 221.162L374.26 231.152V219.399L391.563 209.41V221.162Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26 237.048L416.614 212.596V206.698L374.26 231.152V237.048Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31 216.688L416.613 206.698V194.946L399.31 204.936V216.688Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.563 253.434L374.26 263.423V251.672L391.563 241.683V253.434Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26 269.32L416.614 244.867V238.97L374.26 263.422V269.32Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31 248.96L416.613 238.97V227.22L399.31 237.209V248.96Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.563 285.707L374.26 295.697V283.945L391.563 273.955V285.707Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26 301.593L416.614 277.141V271.244L374.26 295.697V301.593Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31 281.233L416.613 271.244V259.491L399.31 269.481V281.233Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.563 317.979L374.26 327.969V316.218L391.563 306.228V317.979Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26 333.866L416.614 309.414V303.517L374.26 327.969V333.866Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31 313.505L416.613 303.516V291.764L399.31 301.755V313.505Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.563 350.253L374.26 360.243V348.491L391.563 338.501V350.253Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26 366.14L416.614 341.687V335.79L374.26 360.243V366.14Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31 345.78L416.613 335.79V324.038L399.31 334.028V345.78Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.563 382.525L374.26 392.515V380.763L391.563 370.773V382.525Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26 398.413L416.614 373.96V368.062L374.26 392.515V398.413Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31 378.052L416.613 368.062V356.311L399.31 366.299V378.052Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.563 414.799L374.26 424.787V413.036L391.563 403.046V414.799Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26 430.685L416.614 406.233V400.335L374.26 424.787V430.685Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31 410.325L416.613 400.335V388.583L399.31 398.573V410.325Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.583 188.348L167.594 95.9776V50.3887L327.583 142.758V188.348Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.63 110.034L196.119 102.81V78.1924L208.63 85.4152V110.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.773 127.436L226.262 120.214V95.5957L238.773 102.82V127.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.915 144.839L256.405 137.616V112.998L268.915 120.221V144.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.059 162.242L286.547 155.019V130.401L299.059 137.625V162.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.055 145.352L327.583 188.348V142.758L402.055 99.7617V145.352Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.351 158.637L349.839 165.861V141.243L362.351 134.02V158.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.8 148.564L367.288 155.787V131.169L379.8 123.945V148.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.549 142.803L167.561 50.4324L242.031 7.4375L402.019 99.8065L327.549 142.803Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.51 99.7478L239.042 63.681V45.8799L301.51 81.9467V99.7478Z",
    fill: "#FF6FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.588 82.9593L301.51 99.7481V81.9469L330.588 65.1582V82.9593Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.496 81.9637L239.029 45.898L268.105 29.1104L330.573 65.1761L301.496 81.9637Z",
    fill: "#FF9FC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.045 497.416L301.934 497.548C301.934 497.548 302.389 500.595 305.909 501.422L306.335 501.669L306.447 501.537L306.381 501.333C304.873 497.305 303.399 497.138 302.045 497.416Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.205 495.297C306.856 495.7 305.599 496.564 306.053 500.934L306.085 501.15L306.246 501.215L306.519 500.786C309.327 498.336 308.365 495.362 308.365 495.362L308.205 495.297Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.31 496.128L310.187 496.221C310.187 496.221 309.997 498.991 312.928 500.448L313.254 500.754L313.378 500.662L313.359 500.468C312.816 496.618 311.553 496.164 310.31 496.128Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.187 496.221C310.187 496.221 310.388 496.548 313.254 500.754L313.236 500.561C312.692 496.711 311.43 496.257 310.187 496.221Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.331 500.525L313.194 500.728L313.277 500.912L313.825 500.781C317.978 501.047 319.435 497.829 319.435 497.829L319.353 497.646C317.942 496.883 316.258 496.574 313.331 500.525Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.269 495.145L304.196 495.31C304.196 495.31 305.523 498.186 309.244 497.919L309.737 498.032L309.81 497.867L309.686 497.686C307.036 494.163 305.528 494.452 304.269 495.145Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.719 488.931C311.726 488.989 309.702 489.716 308.83 495.891L308.8 496.201L308.998 496.349L309.522 495.859C314.222 493.522 313.917 489.079 313.917 489.079L313.719 488.931Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.573 501.005C305.055 501.005 303.042 504.217 302.99 505.182C302.933 506.232 303.575 507.293 304.916 508.094C306.202 508.863 307.887 509.248 309.573 509.248C311.258 509.248 312.944 508.863 314.23 508.094C315.571 507.293 316.212 506.232 316.156 505.182C316.156 503.623 314.09 501.005 309.573 501.005Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.537 494.526C302.323 494.755 302.328 495.119 302.548 495.341C306.252 499.065 306.237 503.996 306.236 504.046C306.232 504.363 306.477 504.625 306.784 504.63C306.787 504.63 306.79 504.63 306.793 504.63C307.096 504.63 307.344 504.378 307.348 504.062C307.352 503.841 307.382 498.595 303.323 494.514C303.103 494.293 302.751 494.298 302.537 494.526Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.456 493.576C312.342 497.258 311.921 503.674 311.905 503.945C311.887 504.263 312.12 504.536 312.427 504.555C312.438 504.556 312.45 504.556 312.461 504.556C312.753 504.556 312.998 504.321 313.016 504.015C313.019 503.954 313.421 497.816 317.183 494.447C317.416 494.24 317.441 493.876 317.24 493.635C317.04 493.394 316.688 493.368 316.456 493.576Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.058 492.58C304.178 492.415 304.27 492.256 304.322 492.111C304.414 491.866 304.233 491.496 304.233 491.496C304.233 491.496 304.076 491.435 303.819 491.388C303.077 491.253 302.46 491.692 301.991 492.282C301.832 491.761 301.4 491.47 300.421 491.946C299.285 492.497 299.331 493.197 299.695 493.759C298.864 494.002 298.158 494.421 298.118 495.133C298.112 495.247 298.078 495.268 298.078 495.268C298.078 495.268 298.21 495.261 298.16 495.367C298.57 495.702 299.254 495.658 299.658 495.523C299.327 496.005 299.158 496.575 299.158 496.575C299.158 496.575 299.245 496.823 299.814 496.822C300.626 496.81 301.306 496.558 301.64 495.982C302.185 496.284 302.757 496.128 303.542 495.387C304.205 494.691 303.97 494.413 303.97 494.413C303.97 494.413 303.962 494.459 303.873 494.392C304.725 494.14 305.339 493.562 305.36 492.843C305.364 492.641 305.345 492.54 305.302 492.458C305.124 492.124 304.693 492.379 304.058 492.58Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.239 493.735C300.629 494.189 300.951 494.503 301.216 494.51C302.045 494.531 305.318 494.315 305.364 492.777C305.411 491.238 301.849 493.281 301.239 493.735Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71 491.174C301.959 490.855 300.904 493.736 300.844 494.249C300.785 494.762 301.462 494.595 301.726 494.41C302.553 493.831 305.462 491.494 303.71 491.174Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.312 491.732C298.185 492.765 300.201 494.317 300.691 494.51C301.181 494.704 301.691 494.216 301.762 493.99C301.984 493.282 302.439 490.699 300.312 491.732Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.166 493.238C301.345 493.203 298.097 493.368 298.009 494.919C297.921 496.471 301.506 494.467 302.122 494.02C302.739 493.572 302.429 493.25 302.166 493.238Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.041 493.622C300.322 494.277 297.878 496.85 299.858 496.821C301.838 496.792 302.126 494.069 302.038 493.607C301.951 493.145 301.271 493.412 301.041 493.622Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.228 493.731C300.553 493.81 300.324 494.336 300.402 494.511C300.645 495.06 301.922 496.917 303.563 495.368C305.203 493.82 301.903 493.653 301.228 493.731Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.286 493.024C300.54 493.4 300.084 494.079 300.266 494.539C300.448 495 301.199 495.069 301.945 494.693C302.69 494.317 303.147 493.638 302.965 493.177C302.783 492.716 302.031 492.648 301.286 493.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.596 488.979C305.36 488.749 304.989 488.76 304.766 489.004C304.544 489.248 304.555 489.633 304.79 489.863C310.031 494.988 309.72 505.16 309.716 505.262C309.704 505.597 309.956 505.879 310.28 505.892C310.288 505.893 310.295 505.893 310.303 505.893C310.617 505.893 310.877 505.636 310.889 505.309C310.906 504.869 311.228 494.486 305.596 488.979Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.942 494.169C321.942 494.169 321.893 494.148 321.864 493.997C321.679 493.052 320.658 492.629 319.501 492.467C319.885 491.643 319.819 490.697 318.197 490.181C316.8 489.737 316.275 490.211 316.156 490.94C315.42 490.242 314.514 489.775 313.545 490.102C313.21 490.215 313.01 490.327 313.01 490.327C313.01 490.327 312.837 490.858 313.004 491.168C313.101 491.353 313.253 491.547 313.443 491.745C312.556 491.601 311.933 491.343 311.756 491.826C311.713 491.944 311.707 492.082 311.748 492.352C311.908 493.31 312.835 493.964 314.023 494.134C313.915 494.241 313.897 494.181 313.897 494.181C313.897 494.181 313.632 494.6 314.648 495.402C315.834 496.24 316.629 496.336 317.303 495.825C317.855 496.531 318.812 496.734 319.902 496.591C320.664 496.48 320.734 496.131 320.734 496.131C320.734 496.131 320.404 495.402 319.873 494.821C320.439 494.922 321.363 494.848 321.851 494.319C321.764 494.186 321.942 494.169 321.942 494.169Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.429 492.739C316.529 492.251 311.386 490.214 311.73 492.265C312.074 494.316 316.496 493.963 317.602 493.771C317.956 493.71 318.329 493.227 317.429 492.739Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.652 489.794C311.365 490.566 315.688 493.125 316.9 493.737C317.287 493.933 318.225 494.023 318.052 493.349C317.878 492.674 315.939 489.022 313.652 489.794Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.304 489.874C315.267 488.909 316.349 492.278 316.775 493.183C316.911 493.471 317.684 494.024 318.305 493.669C318.925 493.314 321.341 490.84 318.304 489.874Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.096 492.255C315.747 492.322 315.391 492.814 316.299 493.292C317.206 493.771 322.372 495.749 321.97 493.69C321.569 491.63 317.19 492.047 316.096 492.255Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.673 492.548C317.327 492.313 316.368 492.089 316.335 492.724C316.303 493.36 317.186 496.95 319.843 496.6C322.499 496.25 318.757 493.284 317.673 492.548Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.443 492.73C316.525 492.758 312.137 493.629 314.616 495.38C317.096 497.132 318.467 494.395 318.692 493.612C318.764 493.362 318.361 492.702 317.443 492.73Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.236 491.795C316.169 491.437 315.175 491.677 315.016 492.33C314.857 492.982 315.592 493.801 316.659 494.159C317.726 494.516 318.72 494.277 318.879 493.624C319.039 492.971 318.303 492.152 317.236 491.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.898 487.549C309.396 487.193 310.039 486.43 310.03 485.658C309.87 485.624 309.992 485.476 309.992 485.476C309.992 485.476 309.94 485.497 309.81 485.406C308.998 484.835 307.926 485.297 306.939 486.06C306.641 485.145 305.917 484.483 304.327 485.335C302.957 486.068 302.899 486.827 303.33 487.466C302.277 487.504 301.261 487.845 300.764 488.832C300.592 489.174 300.522 489.411 300.522 489.411C300.522 489.411 300.77 489.944 301.117 490.049C301.321 490.115 301.575 490.145 301.859 490.148C301.088 490.718 300.435 491 300.645 491.499C300.697 491.622 300.791 491.73 301.014 491.902C301.819 492.501 302.983 492.285 303.999 491.505C303.994 491.668 303.938 491.637 303.938 491.637C303.938 491.637 304.038 492.155 305.374 491.983C306.866 491.707 307.533 491.172 307.677 490.271C308.596 490.381 309.462 489.802 310.181 488.861C310.676 488.195 310.481 487.878 310.481 487.878C310.481 487.878 309.712 487.581 308.898 487.549Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.571 487.849C304.545 488.169 299.218 490.568 300.939 491.85C302.66 493.132 305.74 489.485 306.438 488.495C306.66 488.178 306.597 487.529 305.571 487.849Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.475 487.832C305.863 487.456 301.799 486.188 300.626 488.518C299.452 490.849 304.534 489.472 305.884 489.006C306.315 488.857 307.086 488.209 306.475 487.832Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.188 485.021C301.211 486.616 304.429 488.327 305.395 488.683C305.703 488.797 306.679 488.622 306.894 487.88C307.108 487.138 307.165 483.426 304.188 485.021Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.671 485.092C307.9 483.847 304.897 487.51 304.222 488.503C304.006 488.82 304.089 489.463 305.114 489.13C306.139 488.797 311.442 486.337 309.671 485.092Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.619 487.518C305.19 487.605 304.308 488.171 304.737 488.674C305.165 489.178 308.39 491.207 310.142 488.912C311.895 486.616 306.96 487.244 305.619 487.518Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.576 487.832C304.904 488.555 302.218 492.567 305.335 491.991C308.453 491.414 307.534 488.304 307.146 487.542C307.022 487.298 306.248 487.109 305.576 487.832Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.753 487.285C303.694 487.832 303.116 488.772 303.461 489.386C303.807 490 304.945 490.054 306.003 489.508C307.062 488.961 307.64 488.021 307.295 487.407C306.95 486.793 305.812 486.738 304.753 487.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.045 386.416L116.934 386.548C116.934 386.548 117.389 389.595 120.909 390.422L121.335 390.669L121.447 390.537L121.381 390.333C119.873 386.305 118.399 386.138 117.045 386.416Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.205 384.297C121.856 384.7 120.599 385.564 121.053 389.934L121.085 390.15L121.246 390.215L121.519 389.786C124.327 387.336 123.365 384.362 123.365 384.362L123.205 384.297Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.31 385.128L125.187 385.221C125.187 385.221 124.997 387.991 127.928 389.448L128.254 389.754L128.378 389.662L128.359 389.468C127.816 385.618 126.553 385.164 125.31 385.128Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.187 385.221C125.187 385.221 125.388 385.548 128.254 389.754L128.236 389.561C127.692 385.711 126.43 385.257 125.187 385.221Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.331 389.525L128.194 389.728L128.277 389.912L128.825 389.781C132.978 390.047 134.435 386.829 134.435 386.829L134.353 386.646C132.942 385.883 131.258 385.574 128.331 389.525Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.269 384.145L119.196 384.31C119.196 384.31 120.523 387.186 124.244 386.919L124.737 387.032L124.81 386.867L124.686 386.686C122.036 383.163 120.528 383.452 119.269 384.145Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.719 377.931C126.726 377.989 124.702 378.716 123.83 384.891L123.8 385.201L123.998 385.349L124.522 384.859C129.222 382.522 128.917 378.079 128.917 378.079L128.719 377.931Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.573 390.005C120.055 390.005 118.042 393.217 117.99 394.182C117.933 395.232 118.575 396.293 119.916 397.094C121.202 397.863 122.887 398.248 124.573 398.248C126.258 398.248 127.944 397.863 129.23 397.094C130.571 396.293 131.212 395.232 131.156 394.182C131.156 392.623 129.09 390.005 124.573 390.005Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.537 383.526C117.323 383.755 117.328 384.119 117.548 384.341C121.252 388.065 121.237 392.996 121.236 393.046C121.232 393.363 121.477 393.625 121.784 393.63C121.787 393.63 121.79 393.63 121.793 393.63C122.096 393.63 122.344 393.378 122.348 393.062C122.352 392.841 122.382 387.595 118.323 383.514C118.103 383.293 117.751 383.298 117.537 383.526Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.456 382.576C127.342 386.258 126.921 392.674 126.905 392.945C126.887 393.263 127.12 393.536 127.427 393.555C127.438 393.556 127.45 393.556 127.461 393.556C127.753 393.556 127.998 393.321 128.016 393.015C128.019 392.954 128.421 386.816 132.183 383.447C132.416 383.24 132.441 382.876 132.24 382.635C132.04 382.394 131.688 382.368 131.456 382.576Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.058 381.58C119.178 381.415 119.27 381.256 119.322 381.111C119.414 380.866 119.233 380.496 119.233 380.496C119.233 380.496 119.076 380.435 118.819 380.388C118.077 380.253 117.46 380.692 116.991 381.282C116.832 380.761 116.4 380.47 115.421 380.946C114.285 381.497 114.331 382.197 114.695 382.759C113.864 383.002 113.158 383.421 113.118 384.133C113.112 384.247 113.078 384.268 113.078 384.268C113.078 384.268 113.21 384.261 113.16 384.367C113.57 384.702 114.254 384.658 114.658 384.523C114.327 385.005 114.158 385.575 114.158 385.575C114.158 385.575 114.245 385.823 114.814 385.822C115.626 385.81 116.306 385.558 116.64 384.982C117.185 385.284 117.757 385.128 118.542 384.387C119.205 383.691 118.97 383.413 118.97 383.413C118.97 383.413 118.962 383.459 118.873 383.392C119.725 383.14 120.339 382.562 120.36 381.843C120.364 381.641 120.345 381.54 120.302 381.458C120.124 381.124 119.693 381.379 119.058 381.58Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.239 382.735C115.629 383.189 115.951 383.503 116.216 383.51C117.045 383.531 120.318 383.315 120.364 381.777C120.411 380.238 116.849 382.281 116.239 382.735Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.71 380.174C116.959 379.855 115.904 382.736 115.844 383.249C115.785 383.762 116.462 383.595 116.726 383.41C117.553 382.831 120.462 380.494 118.71 380.174Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.312 380.732C113.185 381.765 115.201 383.317 115.691 383.51C116.181 383.704 116.691 383.216 116.762 382.99C116.984 382.282 117.439 379.699 115.312 380.732Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.166 382.238C116.345 382.203 113.097 382.368 113.009 383.919C112.921 385.471 116.506 383.467 117.122 383.02C117.739 382.572 117.429 382.25 117.166 382.238Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.041 382.622C115.322 383.277 112.878 385.85 114.858 385.821C116.838 385.792 117.126 383.069 117.038 382.607C116.951 382.145 116.271 382.412 116.041 382.622Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.228 382.731C115.553 382.81 115.324 383.336 115.402 383.511C115.645 384.06 116.922 385.917 118.563 384.368C120.203 382.82 116.903 382.653 116.228 382.731Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.286 382.024C115.54 382.4 115.084 383.079 115.266 383.539C115.448 384 116.199 384.069 116.945 383.693C117.69 383.317 118.147 382.638 117.965 382.177C117.783 381.716 117.031 381.648 116.286 382.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.596 377.979C120.36 377.749 119.989 377.76 119.766 378.004C119.544 378.248 119.555 378.633 119.79 378.863C125.031 383.988 124.72 394.16 124.716 394.262C124.704 394.597 124.956 394.879 125.28 394.892C125.288 394.893 125.295 394.893 125.303 394.893C125.617 394.893 125.877 394.636 125.889 394.309C125.906 393.869 126.228 383.486 120.596 377.979Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.942 383.169C136.942 383.169 136.893 383.148 136.864 382.997C136.679 382.052 135.658 381.629 134.501 381.467C134.885 380.643 134.819 379.697 133.197 379.181C131.8 378.737 131.275 379.211 131.156 379.94C130.42 379.242 129.514 378.775 128.545 379.102C128.21 379.215 128.01 379.327 128.01 379.327C128.01 379.327 127.837 379.858 128.004 380.168C128.101 380.353 128.253 380.547 128.443 380.745C127.556 380.601 126.933 380.343 126.756 380.826C126.713 380.944 126.707 381.082 126.748 381.352C126.908 382.31 127.835 382.964 129.023 383.134C128.915 383.241 128.897 383.181 128.897 383.181C128.897 383.181 128.632 383.6 129.648 384.402C130.834 385.24 131.629 385.336 132.303 384.825C132.855 385.531 133.812 385.734 134.902 385.591C135.664 385.48 135.734 385.131 135.734 385.131C135.734 385.131 135.404 384.402 134.873 383.821C135.439 383.922 136.363 383.848 136.851 383.319C136.764 383.186 136.942 383.169 136.942 383.169Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.429 381.739C131.529 381.251 126.386 379.214 126.73 381.265C127.074 383.316 131.496 382.963 132.602 382.771C132.956 382.71 133.329 382.227 132.429 381.739Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.652 378.794C126.365 379.566 130.688 382.125 131.9 382.737C132.287 382.933 133.225 383.023 133.052 382.349C132.878 381.674 130.939 378.022 128.652 378.794Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.304 378.874C130.267 377.909 131.349 381.278 131.775 382.183C131.911 382.471 132.684 383.024 133.305 382.669C133.925 382.314 136.341 379.84 133.304 378.874Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.096 381.255C130.747 381.322 130.391 381.814 131.299 382.292C132.206 382.771 137.372 384.749 136.97 382.69C136.569 380.63 132.19 381.047 131.096 381.255Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.673 381.548C132.327 381.313 131.368 381.089 131.335 381.724C131.303 382.36 132.186 385.95 134.843 385.6C137.499 385.25 133.757 382.284 132.673 381.548Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.443 381.73C131.525 381.758 127.137 382.629 129.616 384.38C132.096 386.132 133.467 383.395 133.692 382.612C133.764 382.362 133.361 381.702 132.443 381.73Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.236 380.795C131.169 380.437 130.175 380.677 130.016 381.33C129.857 381.982 130.592 382.801 131.659 383.159C132.726 383.516 133.72 383.277 133.879 382.624C134.039 381.971 133.303 381.152 132.236 380.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.898 376.549C124.396 376.193 125.039 375.43 125.03 374.658C124.87 374.624 124.992 374.476 124.992 374.476C124.992 374.476 124.94 374.497 124.81 374.406C123.998 373.835 122.926 374.297 121.939 375.06C121.641 374.145 120.917 373.483 119.327 374.335C117.957 375.068 117.899 375.827 118.33 376.466C117.277 376.504 116.261 376.845 115.764 377.832C115.592 378.174 115.522 378.411 115.522 378.411C115.522 378.411 115.77 378.944 116.117 379.049C116.321 379.115 116.575 379.145 116.859 379.148C116.088 379.718 115.435 380 115.645 380.499C115.697 380.622 115.791 380.73 116.014 380.902C116.819 381.501 117.983 381.285 118.999 380.505C118.994 380.668 118.938 380.637 118.938 380.637C118.938 380.637 119.038 381.155 120.374 380.983C121.866 380.707 122.533 380.172 122.677 379.271C123.596 379.381 124.462 378.802 125.181 377.861C125.676 377.195 125.481 376.878 125.481 376.878C125.481 376.878 124.712 376.581 123.898 376.549Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.571 376.849C119.545 377.169 114.218 379.568 115.939 380.85C117.66 382.132 120.74 378.485 121.438 377.495C121.66 377.178 121.597 376.529 120.571 376.849Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.475 376.832C120.863 376.456 116.799 375.188 115.626 377.518C114.452 379.849 119.534 378.472 120.884 378.006C121.315 377.857 122.086 377.209 121.475 376.832Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.188 374.021C116.211 375.616 119.429 377.327 120.395 377.683C120.703 377.797 121.679 377.622 121.894 376.88C122.108 376.138 122.165 372.426 119.188 374.021Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.671 374.092C122.9 372.847 119.897 376.51 119.222 377.503C119.006 377.82 119.089 378.463 120.114 378.13C121.139 377.797 126.442 375.337 124.671 374.092Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.619 376.518C120.19 376.605 119.308 377.171 119.737 377.674C120.165 378.178 123.39 380.207 125.142 377.912C126.895 375.616 121.96 376.244 120.619 376.518Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.576 376.832C119.904 377.555 117.218 381.567 120.335 380.991C123.453 380.414 122.534 377.304 122.146 376.542C122.022 376.298 121.248 376.109 120.576 376.832Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.753 376.285C118.694 376.832 118.116 377.772 118.461 378.386C118.807 379 119.945 379.054 121.003 378.508C122.062 377.961 122.64 377.021 122.295 376.407C121.95 375.793 120.812 375.738 119.753 376.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9528 373.152L45.8975 402.156L45.8817 411.081C45.8817 411.689 45.4715 412.305 44.6667 412.778C43.0414 413.725 40.3982 413.717 38.7571 412.778C37.9287 412.297 37.5183 411.673 37.5341 411.058L37.5499 402.077L37.6052 373.145C37.6052 373.768 38.0154 374.384 38.8281 374.849C40.4692 375.796 43.1123 375.796 44.7377 374.849C45.5346 374.384 45.9528 373.776 45.9528 373.152Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5975 382.079L37.5581 402.07C38.8126 402.748 40.2723 403.103 41.8108 403.103C43.2705 403.103 44.6749 402.788 45.8978 402.156L45.9373 382.079H37.5896H37.5975Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4481 357.905L76.3928 377.485C76.3928 377.841 76.1562 378.204 75.6907 378.48C75.0516 378.851 41.5823 398.312 43.5311 397.184L43.5864 377.604L75.7459 358.9C76.2114 358.623 76.4481 358.268 76.4481 357.905Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5858 377.604L43.5306 397.184C42.5838 397.736 41.0531 397.736 40.0984 397.184C19.2847 385.156 24.4447 388.148 7.72586 378.48C7.24458 378.204 7 377.848 7 377.485L7.07098 357.905C7.07098 358.26 7.30769 358.631 7.7732 358.9L40.1536 377.604C41.1004 378.156 42.6311 378.156 43.5858 377.604Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7374 356.911C76.6921 357.464 76.6921 358.348 75.7453 358.9L43.5779 377.596C42.6311 378.149 41.1004 378.149 40.1457 377.596L7.77316 358.9C6.81847 358.348 6.81847 357.464 7.76526 356.911L39.9327 338.215C40.8795 337.663 42.4101 337.663 43.3648 338.215L75.7374 356.911Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1224 338.791L71.0751 355.364C71.0751 355.664 70.8778 355.972 70.4833 356.201L43.2629 372.024L43.3103 355.451L70.5307 339.628C70.9252 339.391 71.1303 339.091 71.1303 338.791H71.1224Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2939 355.451L43.2466 372.024C42.4497 372.49 41.1479 372.49 40.3431 372.024L12.9491 356.209C12.5388 355.972 12.3416 355.664 12.3416 355.356L12.3889 338.791C12.3889 339.099 12.594 339.399 12.9964 339.628L40.3904 355.451C41.1952 355.917 42.4971 355.917 43.2939 355.451Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5136 337.946C71.3183 338.412 71.3262 339.162 70.5215 339.627L43.3011 355.451C42.5042 355.916 41.2023 355.916 40.3975 355.451L13.0035 339.627C12.1988 339.162 12.1909 338.412 12.9956 337.946L40.2161 322.123C41.0129 321.657 42.3148 321.657 43.1196 322.123L70.5136 337.946Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6007 320.836L66.5613 334.86C66.5613 335.113 66.3956 335.373 66.0563 335.563L43.0176 348.955L43.057 334.931L66.0957 321.538C66.435 321.341 66.6007 321.089 66.6007 320.828V320.836Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0576 334.94L43.0182 348.964C42.3396 349.359 41.243 349.359 40.5644 348.964L17.3837 335.579C17.0365 335.382 16.8708 335.121 16.8708 334.861L16.9103 320.845C16.9103 321.105 17.0838 321.358 17.4231 321.555L40.6039 334.948C41.2824 335.342 42.387 335.342 43.0576 334.948V334.94Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0884 320.126C66.767 320.521 66.7749 321.16 66.0963 321.547L43.0576 334.94C42.3791 335.334 41.2824 335.334 40.6038 334.94L17.4152 321.547C16.7367 321.152 16.7288 320.513 17.4073 320.126L40.446 306.733C41.1246 306.339 42.2213 306.339 42.8998 306.733L66.0884 320.126Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2473 320.132C32.486 320.851 32.4939 322.011 31.2631 322.729C30.0323 323.447 28.0282 323.447 26.7894 322.729C25.5507 322.011 25.5429 320.851 26.7737 320.132C28.0045 319.414 30.0086 319.414 31.2473 320.132Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1051 323.711C48.1229 324.295 48.1308 325.249 47.113 325.841C46.1031 326.425 44.4541 326.425 43.4363 325.841C42.4185 325.257 42.4106 324.302 43.4205 323.711C44.4304 323.126 46.0794 323.119 47.0972 323.711H47.1051Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1978 312.422C47.3497 313.085 47.3576 314.166 46.2135 314.837C45.0695 315.508 43.2075 315.5 42.0476 314.837C40.8878 314.174 40.8878 313.093 42.0318 312.422C43.1759 311.751 45.0379 311.759 46.1978 312.422Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.953 377.152L545.898 406.156L545.882 415.081C545.882 415.689 545.471 416.305 544.667 416.778C543.041 417.725 540.398 417.717 538.757 416.778C537.929 416.297 537.518 415.673 537.534 415.058L537.55 406.077L537.605 377.145C537.605 377.768 538.015 378.384 538.828 378.849C540.469 379.796 543.112 379.796 544.738 378.849C545.535 378.384 545.953 377.776 545.953 377.152Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.598 386.079L537.558 406.07C538.813 406.748 540.272 407.103 541.811 407.103C543.27 407.103 544.675 406.788 545.898 406.156L545.937 386.079H537.59H537.598Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.448 361.905L576.393 381.485C576.393 381.841 576.156 382.204 575.691 382.48C575.052 382.851 541.582 402.312 543.531 401.184L543.586 381.604L575.746 362.9C576.211 362.623 576.448 362.268 576.448 361.905Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.586 381.604L543.531 401.184C542.584 401.736 541.053 401.736 540.098 401.184C519.285 389.156 524.445 392.148 507.726 382.48C507.245 382.204 507 381.848 507 381.485L507.071 361.905C507.071 362.26 507.308 362.631 507.773 362.9L540.154 381.604C541.1 382.156 542.631 382.156 543.586 381.604Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.737 360.911C576.692 361.464 576.692 362.348 575.745 362.9L543.578 381.596C542.631 382.149 541.1 382.149 540.146 381.596L507.773 362.9C506.818 362.348 506.818 361.464 507.765 360.911L539.933 342.215C540.879 341.663 542.41 341.663 543.365 342.215L575.737 360.911Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.122 342.791L571.075 359.364C571.075 359.664 570.878 359.972 570.483 360.201L543.263 376.024L543.31 359.451L570.53 343.628C570.925 343.391 571.13 343.091 571.13 342.791H571.122Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.294 359.451L543.246 376.024C542.449 376.49 541.148 376.49 540.343 376.024L512.949 360.209C512.539 359.972 512.341 359.664 512.341 359.356L512.389 342.791C512.389 343.099 512.594 343.399 512.996 343.628L540.39 359.451C541.195 359.917 542.497 359.917 543.294 359.451Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.513 341.946C571.318 342.412 571.326 343.162 570.521 343.627L543.301 359.451C542.504 359.916 541.202 359.916 540.397 359.451L513.003 343.627C512.198 343.162 512.19 342.412 512.995 341.946L540.216 326.123C541.012 325.657 542.314 325.657 543.119 326.123L570.513 341.946Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.6 324.836L566.561 338.86C566.561 339.113 566.395 339.373 566.056 339.563L543.017 352.955L543.057 338.931L566.095 325.538C566.435 325.341 566.6 325.089 566.6 324.828V324.836Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.057 338.94L543.018 352.964C542.339 353.359 541.243 353.359 540.564 352.964L517.383 339.579C517.036 339.382 516.871 339.121 516.871 338.861L516.91 324.845C516.91 325.105 517.084 325.358 517.423 325.555L540.604 338.948C541.282 339.342 542.387 339.342 543.057 338.948V338.94Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.088 324.126C566.767 324.521 566.775 325.16 566.096 325.547L543.058 338.94C542.379 339.334 541.282 339.334 540.604 338.94L517.415 325.547C516.737 325.152 516.729 324.513 517.407 324.126L540.446 310.733C541.125 310.339 542.221 310.339 542.9 310.733L566.088 324.126Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.247 324.132C532.486 324.851 532.494 326.011 531.263 326.729C530.032 327.447 528.028 327.447 526.789 326.729C525.551 326.011 525.543 324.851 526.774 324.132C528.005 323.414 530.009 323.414 531.247 324.132Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.105 327.711C548.123 328.295 548.131 329.249 547.113 329.841C546.103 330.425 544.454 330.425 543.436 329.841C542.418 329.257 542.411 328.302 543.42 327.711C544.43 327.126 546.079 327.119 547.097 327.711H547.105Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.198 316.422C547.35 317.085 547.358 318.166 546.214 318.837C545.069 319.508 543.207 319.5 542.048 318.837C540.888 318.174 540.888 317.093 542.032 316.422C543.176 315.751 545.038 315.759 546.198 316.422Z",
    fill: "#FF3F83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5131_565702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 584,
    height: 605.563,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedio);
export default __webpack_public_path__ + "static/media/medio.2a8ad3ff7b90c199dcfdb2499bdf8a04.svg";
export { ForwardRef as ReactComponent };